import { render, staticRenderFns } from "./xizaoka_update.vue?vue&type=template&id=3e37afa6&scoped=true&"
import script from "./xizaoka_update.vue?vue&type=script&lang=js&"
export * from "./xizaoka_update.vue?vue&type=script&lang=js&"
import style0 from "./xizaoka_update.vue?vue&type=style&index=0&id=3e37afa6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e37afa6",
  null
  
)

export default component.exports